import { Stack, type StackProps, Typography } from "@mui/material";
import type { FC } from "react";

type Props = Omit<
	StackProps,
	"direction" | "alignItems" | "justifyContent" | "children"
> & {
	label: string;
	value: string;
	suffix: string;
};

export const InspirationRemainingTotal: FC<Props> = ({
	label,
	value,
	suffix,
	...stackProps
}) => (
	<Stack
		direction="row"
		alignItems="baseline"
		justifyContent="space-between"
		{...stackProps}
	>
		<Typography variant="bodyMedium">{label}</Typography>
		<Typography variant="subtitle3" tabular>
			{value}
			<Typography component="span" variant="button" color="inherit" muted>
				{suffix}
			</Typography>
		</Typography>
	</Stack>
);
